import Head from 'next/head';
import useTimeout from 'src/hooks/useTimeout';
interface MetaRefreshInfo {
  redirectUrl: string;
  delay: number;
}
interface MetaRefreshProps {
  metaRefreshInfo: MetaRefreshInfo;
}
const MetaRefresh: React.FC<MetaRefreshProps> = ({
  metaRefreshInfo
}) => {
  // meta refresh를 차단하는 브라우저/네트워크 환경에서도 리다이렉트 가능하도록 백업 코드
  useTimeout(() => {
    window.location.replace(metaRefreshInfo.redirectUrl);
  }, metaRefreshInfo.delay * 1000);
  return <Head data-sentry-element="Head" data-sentry-component="MetaRefresh" data-sentry-source-file="index.tsx">
      <meta httpEquiv='refresh' content={`${metaRefreshInfo.delay}; url=${metaRefreshInfo.redirectUrl}`} data-sentry-element="meta" data-sentry-source-file="index.tsx" />
    </Head>;
};
export default MetaRefresh;